
import { Component, Vue, Prop } from 'vue-property-decorator';
import FileUploader from './FileUploader.vue';

@Component({
  components: {
    FileUploader,
  },
})
export default class FileUploadCounter extends Vue {
  @Prop({ default: '' }) title!: string;

  @Prop({ default: 'Documents' }) headerTitle!: string;

  @Prop({ default: 0 }) numberOfFiles!: number;
}
